import React from 'react';
import { FC } from 'react';
import { useRouter } from 'next/router';
import { Icons } from '@components/Icon';
import useTranslations from '@hooks/useTranslation';
import ButtonTemplate from '@ui/Button/Button';
import {
    CloseButton,
    Description,
    DescriptionBold,
    Header,
    Modal,
    ModalContent,
    Wrapper,
    Icon,
    ButtonBox,
} from './GeneralInfoModal.elements';
import { Highlighted } from '@components/SubscriptionPackages/Packages.elements';

interface ConferenceProps {
    onClose: () => void;
}

const GeneralInfoModalTemplate: FC<ConferenceProps> = ({ onClose }) => {
    const { t } = useTranslations();

    const router = useRouter();

    return (
        <Wrapper>
            <Modal>
                <ModalContent>
                    <Header>

                        <CloseButton onClick={onClose}>
                            <Icon name={Icons.Xmark} />
                        </CloseButton>

                    </Header>

                    <DescriptionBold>Od 15. 11. 2026 opouštíme Karlovo náměstí!</DescriptionBold>
                    <Description>
                        Všechny prezenční kurzy se budou konat pouze na těchto adresách:
                    </Description>

                    <Description>
                        <ul>
                            <li>Novotného lávka 5, Praha 1</li>
                            <li><Highlighted>NOVĚ:</Highlighted> Jablonského 640/2, Praha 7 – Holešovice (4. patro)</li>
                        </ul>
                    </Description>

                    <Description>
                        Přesné místo konání si včas zkontrolujte v detailu svého kurzu.
                    </Description>

                    <ButtonBox>
                        <ButtonTemplate
                            onClick={() =>
                                router.push({
                                    pathname: '/clanek/od-15-11-2026-se-stehujeme-do-novych-prostor-v-prazskych-holesovicich',
                                })
                            }
                            marginTop={25}
                            text={t('homepage.calendar.button.detail')}
                        />
                    </ButtonBox>

                </ModalContent>
            </Modal>
        </Wrapper>
    );
};

export default GeneralInfoModalTemplate;
